import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CookieService } from 'ngx-cookie-service';
import { User } from 'src/app/Models/Commonmodule/user';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
})
export class UsersComponent implements OnInit {
  formTitle = 'Manage Users';
  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  dataList = [];
  loadingRecords = true;
  sortValue: string = 'desc';
  sortKey: string = 'ID';
  searchText: string = '';
  filterQuery: string = '';
  isFilterApplied: string = 'default';
  drawerData2: string[];
  //drawer Variables
  drawerVisible: boolean;
  drawerTitle: string;
  drawerData: User = new User();
  userId = sessionStorage.getItem('userId');
  userName = sessionStorage.getItem('userName');
  roleId: any = sessionStorage.getItem('roleId');

  roleID: any = this.cookie.get('roleId');

  constructor(
    private api: ApiService,
    private message: NzNotificationService,
    private cookie: CookieService
  ) {}
  columns: any[] = [];

  ngOnInit() {
    // Optionally check session variables here
    // if (this.userId == null || this.userName == null || this.roleId == null) {
    //   this.api.logoutForSessionValues();
    // } else {
    //   this.search();
    // }

    this.search();

    // Conditionally set columns based on roleId
    if (this.roleID == 10) {
      this.columns = [
        ['TASK_CATEGORY_NAME', 'Category'],
        ['EMPLOYEE_ID', 'Employee ID'],
         ['NAME', 'Name'],
        ['EMAIL_ID', 'Email'],
        ['MOBILE_NUMBER', 'Mobile'],
        ['RATE_PER_HOUR', 'Rate(Per Hour)'],
      ];
    } else {
      this.columns = [
        ['TASK_CATEGORY_NAME', 'Category'],
          ['EMPLOYEE_ID', 'Employee ID'],
        ['NAME', 'Name'],
        ['EMAIL_ID', 'Email'],
        ['MOBILE_NUMBER', 'Mobile'],
      ];
    }

    
  }

  // Basic Methods
  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find((item) => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'desc';

    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    this.search();
  }

  search(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }
    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith('a') ? 'asc' : 'desc';
    } catch (error) {
      sort = '';
    }

    var likeQuery = '';
    if (this.searchText != '') {
      if (this.roleId != '1') likeQuery += ' AND (';
      // likeQuery=" AND ID IN (select USER_ID from view_user_role_mapping where PARENT_ID="+this.roleId +") AND("
      // else
      // likeQuery = " AND ID IN (select USER_ID from view_user_role_mapping) AND("

      this.columns.forEach((column) => {
        likeQuery += ' ' + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2) + ')';
    } else {
      // if(this.roleId!="1")
      // likeQuery=" AND ID IN (select USER_ID from view_user_role_mapping where PARENT_ID="+this.roleId +") "
      // else
      // likeQuery=" AND ID IN (select USER_ID from view_user_role_mapping)"
    }

    this.api
      .getAllUsers(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery)
      .subscribe(
        (data) => {
          if (data['code'] == 200) {
            this.loadingRecords = false;
            this.totalRecords = data['count'];
            this.dataList = data['data'];
          } else {
            this.loadingRecords = false;
            this.totalRecords = 0;
            this.dataList = [];
          }
        },
        (err) => {
          if (err['ok'] == false) this.message.error('Server Not Found', '');
        }
      );

    // this.api.getAllUserMappingData(this.pageIndex, this.pageSize, this.sortKey, sort, "").subscribe(data => {
    //
    //   this.loadingRecords = false;
    //   this.totalRecords = data['count'];
    //   this.dataList = data['data'];
    // }, err => {
    //
    //   if (err['ok'] == false)
    //     this.message.error("Server Not Found", "");
    //  });
  }

  drawerClose(): void {
    this.search();
    this.drawerVisible = false;
  }

  get closeCallback() {
    return this.drawerClose.bind(this);
  }

  add(): void {
    this.drawerTitle = 'Create New User';
    this.drawerData = new User();
    this.drawerData.IS_ACTIVE = true;
    this.drawerVisible = true;

    this.api.getAllUsers(1, 1, '', 'desc', '').subscribe(
      (data) => {
        if (data['code'] == 200) {
          if (data['count'] == 0) {
            this.drawerData.SEQ_NO = 1;
          } else {
            this.drawerData.SEQ_NO = data['data'][0]['SEQ_NO'] + 1;
          }
        } else {
        }
      },
      (err) => {}
    );
  }

  edit(data: User): void {
    this.drawerVisible = true;
    this.drawerTitle = 'Update User';
    // this.drawerData = Object.assign({}, data);

    this.drawerData.CLIENT_ID = data.CLIENT_ID;
    this.drawerData.ID = data.ID;
    this.drawerData.NAME = data.NAME;
    this.drawerData.MOBILE_NUMBER = data.MOBILE_NUMBER;
    this.drawerData.EMAIL_ID = data.EMAIL_ID;
    this.drawerData.PASSWORD = data.PASSWORD;
    this.drawerData.IS_ACTIVE = data.IS_ACTIVE;
    this.drawerData.ROLE_DATA = data.ROLE_DATA;
    this.drawerData.TASK_CATEGORY_ID = data.TASK_CATEGORY_ID;
    this.drawerData.RATE_PER_HOUR = data.RATE_PER_HOUR;
    this.drawerData.SEQ_NO = data.SEQ_NO;
    this.drawerData.TEAM_LEAD_ID = data.TEAM_LEAD_ID;
    this.drawerData.EMPLOYEE_ID = data.EMPLOYEE_ID;

    this.drawerData.ROLE_DATA = data['ROLE_IDS'].split(',');
    for (var i = 0; i < this.drawerData.ROLE_DATA.length; i++) {
      this.drawerData.ROLE_DATA[i] = Number(this.drawerData.ROLE_DATA[i]);
    }
  }

  // Actions
  scroll = { x: '300px', y: '400px' };

  mapAuthorityDrawerVisible: boolean = false;
  mapAuthorityDrawerTitle = 'Map Qualifications';
  AuthorityIndeterminate: any = [];
  checkedQualifications = false;
  mapAuthoritySelectedItems: any = [];
  mapAuthoritySetOfCheckedId = new Set<number>();
  totalQualificationRecords = 1;
  QUALIFICATION_SELECTED_RECORDS: any;
  Employee_ID: any;
  qualificationLoadingRecords: boolean = false;
  qualificationPageIndex = 1;
  qualificationPageSize = 10;
  newQualificationSelectedItems: any = [];
  masterQualificationList: any[] = [];
  masterQualificationData: any = [];
  datalist1: any[] = [];

  onQualificationPageDataChange(data: any) {}

  mapAuthority(data: any) {
    // Start loading
    this.qualificationLoadingRecords = true;
    this.loadingRecords = true;

    // Set title and ID
    this.Employee_ID = data.ID;
    this.mapAuthorityDrawerTitle = 'Map Authorities To ' + data.NAME;

    // Fetch master qualification data
    this.api
      .getusersRoleMapping(
        0,
        0,
        this.sortKey,
        'asc',
        'AND ' + 'ROLE_ID IN (1,2,3,6,10)'
      )
      .subscribe({
        next: (response) => {
          this.masterQualificationData = response?.data || [];

          

          // Once master data is fetched, fetch mapped qualifications
          this.api.getMappedQualifications(data.ID).subscribe({
            next: (mappedResponse) => {
              const mappedQualifications = mappedResponse?.data || [];
              const mappedQualificationMap: {
                [key: string]: {
                  id: number;
                  isActive: boolean;
                  // ROLE_NAME: any;
                  // USER_NAME: any;
                };
              } = {};

              // Map the data
              for (const qualification of mappedQualifications) {
                mappedQualificationMap[qualification.AUTHORITY_ID] = {
                  // id: qualification.ID,
                  id: qualification.USER_ID,
                  isActive: qualification.IS_ACTIVE,
                  // USER_NAME: qualification.USER_NAME,
                  // ROLE_NAME: qualification.ROLE_NAME,
                };
              }

              // Combine master and mapped qualifications
              this.mapAuthoritySetOfCheckedId.clear();
              this.mapAuthoritySelectedItems = [];

              for (const qualification of this.masterQualificationData) {
                const mappedQualification =
                  mappedQualificationMap[qualification.USER_ID];

                const isChecked = mappedQualification ? true : false;

                if (isChecked) {
                  this.mapAuthoritySetOfCheckedId.add(qualification.USER_ID);
                }

                this.mapAuthoritySelectedItems.push({
                  ...qualification,
                  checkedQualifications: isChecked,
                  mappedQualificationId: mappedQualification
                    ? mappedQualification.id
                    : null,
                });
              }

              // Update state after data combination
              this.masterQualificationList = [
                ...this.mapAuthoritySelectedItems,
              ];
              this.refreshQualificationCheckedStatus();
            

              this.qualificationLoadingRecords = false;
              this.loadingRecords = false;
              this.mapAuthorityDrawerVisible = true;
            },
            error: () => {
              this.qualificationLoadingRecords = false;
              this.loadingRecords = false;
              this.mapAuthorityDrawerVisible = true;
              this.message.error('Error loading mapped qualifications.', '');
            },
          });
        },
        error: () => {
          this.masterQualificationData = [];
          this.qualificationLoadingRecords = false;
          this.loadingRecords = false;
          this.message.error('Error loading qualifications.', '');
        },
      });

    
  }

  searchQualifications(searchText: any) {
    this.qualificationLoadingRecords = true;
    if (searchText) {
      const searchTextLower = searchText.toLowerCase();
      this.datalist1 = this.masterQualificationList.filter((user) => {
        return user.NAME.toLowerCase().includes(searchTextLower);
      });
      this.mapAuthoritySelectedItems = [...this.datalist1];
    } else {
      this.mapAuthoritySelectedItems = [...this.masterQualificationList];
    }
    this.qualificationLoadingRecords = false;
  }
  onAllQualificationsChecked(value: boolean): void {
    //

    this.mapAuthoritySetOfCheckedId.clear();
    if (value) {
      this.masterQualificationData.forEach((item) =>
        this.mapAuthoritySetOfCheckedId.add(item.USER_ID)
      );
    }
    this.mapAuthoritySelectedItems.forEach(
      (item) => (item.checkedQualifications = value)
    );
    this.refreshQualificationCheckedStatus();
    this.updateTotalQualificationRecords();
  }

  onQualificationItemChecked(id: number, checked: boolean): void {
    //

    this.updateQualificationCheckedSet(id, checked);
    this.mapAuthoritySelectedItems.forEach(
      (data) =>
        (data.checkedQualifications = this.mapAuthoritySetOfCheckedId.has(
          data.ID
        ))
    );
    this.refreshQualificationCheckedStatus();
    this.updateTotalQualificationRecords();
  }

  updateQualificationCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.mapAuthoritySetOfCheckedId.add(id);
    } else {
      this.mapAuthoritySetOfCheckedId.delete(id);
    }
    //
  }

  refreshQualificationCheckedStatus(): void {
    this.checkedQualifications = this.mapAuthoritySelectedItems.every((item) =>
      this.mapAuthoritySetOfCheckedId.has(item.USER_ID)
    );
    this.AuthorityIndeterminate =
      this.mapAuthoritySelectedItems.some((item) =>
        this.mapAuthoritySetOfCheckedId.has(item.USER_ID)
      ) && !this.checkedQualifications;
  }

  updateTotalQualificationRecords(): void {
    this.QUALIFICATION_SELECTED_RECORDS = this.mapAuthoritySetOfCheckedId.size;
  }

  saveQualifications(): void {
    if (this.mapAuthoritySetOfCheckedId.size === 0) {
      this.message.error('Please Check At Least One Authority Member', '');
    } else {
      const checkedQualifications: any[] = [];
      const uncheckedQualifications: any[] = [];

      

      for (let i = 0; i < this.masterQualificationData.length; i++) {
        const qualification = this.masterQualificationData[i];
        const isChecked = this.mapAuthoritySetOfCheckedId.has(
          qualification.USER_ID
        );

        const mappedQualification = this.mapAuthoritySelectedItems.find(
          (item) => item.USER_ID === qualification.USER_ID
        );

        const mappedQualificationId =
          mappedQualification?.mappedQualificationId || null;

        if (isChecked) {
          const qualificationObj: any = {
            AUTHORITY_ID: qualification.USER_ID,
            USER_ID: this.Employee_ID,
            IS_ACTIVE: 1,
          };
          if (mappedQualificationId) {
            qualificationObj.USER_ID = mappedQualificationId; // Include USER_ID only if it exists
          }
          checkedQualifications.push(qualificationObj);
        } else {
          const qualificationObj: any = {
            AUTHORITY_ID: qualification.USER_ID,
            USER_ID: this.Employee_ID,
            IS_ACTIVE: 0,
          };
          if (mappedQualificationId) {
            qualificationObj.USER_ID = mappedQualificationId; // Include USER_ID only if it exists
          }
          uncheckedQualifications.push(qualificationObj);
        }
      }

      const allQualifications = [
        ...checkedQualifications,
        ...uncheckedQualifications,
      ];

      allQualifications.forEach((qualification) => {
        qualification['CLIENT_ID'] = this.api.clientId;
      });

      const dataToSave = { data: allQualifications };

      this.qualificationLoadingRecords = true;
      

      // API call to save the mapped qualifications
      // Uncomment the API call once the API is ready
      this.api.mapQualificationscall(dataToSave).subscribe(
        (response) => {
          if (response.code == 200) {
            this.message.success('Authorities Mapped Successfully', '');
            this.mapAuthorityDrawerVisible = false;
            this.mapAuthoritySetOfCheckedId.clear();
            this.qualificationLoadingRecords = false;
          } else {
            this.message.error('Authority Mapping Failed', '');
            this.qualificationLoadingRecords = false;
          }
        },
        (error) => {
          this.message.error('Authority Mapping Failed', '');
          this.qualificationLoadingRecords = false;
        }
      );
    }
  }

  // Close Qualifications Drawer
  mapQualificationsDrawerClose() {
    this.mapAuthorityDrawerVisible = false;
    this.mapAuthoritySetOfCheckedId.clear();
    this.searchQualifications('');
  }
}
